const dislocated_shoulder = 
{
  "name": "Dislocated Shoulder",
  "meta": {
    links: [
      { label: "Dislocating Shoulder", url: "https://www.myorthopedicproblem.com/services/recurrent-dislocating-shoulder" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "shoulder_arthroplasty": "yes",
    "cause": "sports_injury",
    "pain_description": "acute",
    "swelling": "none,moderate",
    "rom_flexibility": "painful_or_unable",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "front_chest"
  }
}

const frozen_shoulder_capsulitis = 
{
  "name": "Frozen Shoulder Capsulitis",
  "meta": {
    links: [
      { label: "Frozen Shoulder", url: "https://www.myorthopedicproblem.com/services/frozen-shoulder" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "shoulder_arthroplasty": "no",
    "cause": "sports_injury",
    "pain_description": "chronic",
    "swelling": "none,moderate",
    "rom_flexibility": "painful_or_unable",
    "grinding": "no",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "all"
  }
}

const labral_tear = 
{
  "name": "Labral Tear",
  "meta": {
    links: [
      { label: "Labral Tear", url: "https://www.myorthopedicproblem.com/services/labral-tear" }
    ]
  },
  "conditions": {
    "age": "35 or younger,36-50",
    "shoulder_arthroplasty": "no",
    "cause": "sports_injury",
    "pain_description": "acute",
    "swelling": "none,moderate",
    "rom_flexibility": "painful_or_unable",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "front_chest"
  }
}

const shoulder_fracture = 
{
  "name": "Shoulder Fracture",
  "meta": {
    links: [
      { label: "Shoulder Fracture", url: "https://www.myorthopedicproblem.com/services/shoulder-fracture" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "shoulder_arthroplasty": "no",
    "cause": "sports_injury",
    "pain_description": "acute",
    "swelling": "moderate,severe",
    "rom_flexibility": "painful_or_unable",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "all"
  }
}

const mdi_subluxation = 
{
  "name": "MDI Subluxation",
  "meta": {
    links: [
      { label: "Dislocating Shoulder", url: "https://www.myorthopedicproblem.com/services/recurrent-dislocating-shoulder" }
    ]
  },
  "conditions": {
    "age": "35 or younger",
    "shoulder_arthroplasty": "no",
    "cause": "sports_injury",
    "pain_description": "acute,chronic",
    "swelling": "none,moderate",
    "rom_flexibility": "limited",
    "sleeping_issues": "no",
    "pain_increasing": "yes",
    "issues_lifting": "no",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "all"
  }
}

const bicep_tendon_rupture = 
{
  "name": "Bicep Tendon Rupture",
  "meta": {
    links: [
      { label: "Bicep Tendon Rupture", url: "https://www.myorthopedicproblem.com/services/shoulder" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80",
    "shoulder_arthroplasty": "no",
    "cause": "sports_injury",
    "pain_description": "acute",
    "swelling": "none,moderate",
    "rom_flexibility": "painful_or_unable",
    "grinding": "no",
    "sleeping_issues": "no",
    "pain_increasing": "yes",
    "issues_lifting": "no",
    "lifting_arms": "no",
    "arms_behind_back": "yes",
    "pain_location": "front_chest"
  }
}

const impingement_syndrome = 
{
  "name": "Impingement Syndrome",
  "meta": {
    links: [
      { label: "Impingement Syndrome", url: "https://www.myorthopedicproblem.com/services/shoulder-impingement" }
    ]
  },
  "conditions": {
    "shoulder_arthroplasty": "no",
    "swelling": "none",
    "rom_flexibility": "painful_or_unable",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "no",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "front_chest"
  }
}

const rotator_cuff_disease = 
{
  "name": "Rotator Cuff Disease",
  "meta": {
    links: [
      { label: "Rotator Cuff Disease", url: "https://www.myorthopedicproblem.com/services/rotator-cuff-disease" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "shoulder_arthroplasty": "no",
    "cause": "arthritis_tendonitis",
    "swelling": "none",
    "rom_flexibility": "painful_or_unable",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "yes",
    "arms_behind_back": "yes"
  }
}

const ac_joint_arthritis = 
{
  "name": "AC Joint Arthritis",
  "meta": {
    links: [
      { label: "AC Joint Arthritis", url: "https://www.myorthopedicproblem.com/services/ac-joint-arthritis" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "shoulder_arthroplasty": "no",
    "pain_description": "chronic,intermittent",
    "swelling": "none",
    "rom_flexibility": "painful_or_unable",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "no",
    "lifting_arms": "yes",
    "arms_behind_back": "yes",
    "pain_location": "front_chest"
  }
}

const djd_tsa = 
{
  "name": "Degenerative Joint Disease-TSA",
  "meta": {
    links: [
      { label: "AC Joint Arthritis", url: "https://www.myorthopedicproblem.com/services/ac-joint-arthritis" }
    ]
  },
  "conditions": {
    "age": "51-65,66-80,81 or older",
    "shoulder_arthroplasty": "yes",
    "pain_description": "chronic,intermittent",
    "swelling": "none",
    "rom_flexibility": "painful_or_unable",
    "grinding": "yes",
    "sleeping_issues": "yes",
    "pain_increasing": "yes",
    "issues_lifting": "yes",
    "lifting_arms": "no",
    "arms_behind_back": "yes"
  }
}

module.exports = {
  dislocated_shoulder,
  frozen_shoulder_capsulitis,
  labral_tear,
  shoulder_fracture,
  mdi_subluxation,
  bicep_tendon_rupture,
  impingement_syndrome,
  rotator_cuff_disease,
  ac_joint_arthritis,
  djd_tsa
}

